import darkTheme from '../../assets/style/themes/dark';
import lightTheme from '../../assets/style/themes/light';
import { DARK, LIGHT } from '../../assets/style/themes/types';

const strategies = {};
strategies[LIGHT] = function () {
  return lightTheme;
};

strategies[DARK] = function () {
  const theme = {
    ...lightTheme,
    colors: {
      ...lightTheme.colors,
      charts: {
        ...lightTheme.colors.charts,
        colors: [
          ...darkTheme.colors.charts.colors,
        ],
      },
    },
  };

  return theme;
};

function getTheme(type = DARK) {
  if (![DARK, LIGHT].includes(type)) {
    return strategies[DARK]();
  } 

  return strategies[type]();
}

export default getTheme;
